module.exports = {"610305100":"城关镇","610305101":"虢王镇","610305102":"彪角镇","610305103":"横水镇","610305104":"田家庄镇","610305105":"糜杆桥镇","610305107":"南指挥镇","610305108":"陈村镇","610305109":"长青镇","610305110":"柳林镇","610305111":"姚家沟镇","610305112":"范家寨镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610305.json
// module id = 2933
// module chunks = 0